//material ordem servico
export const materialOrdensMaterialApiName: string = 'materiais-ordens-servicos';
export const materialOrdensMaterialRoute: string = 'os-materiais';
export const materialOrdensMateriaistorage: string = 'materialOrdensServico';
export const materialOrdensMaterialComponentName: any = {plural: 'Materiais', single: 'Material'};




/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/materiais-ordem-servico/shared/data.service.ts
 **/